import {
    IonItem,
    IonIcon,
    IonButton,
    useIonActionSheet,
    IonText,
    IonBadge
} from '@ionic/react';
import {
    Row,
    Col
} from 'reactstrap';
import { getMode } from '@ionic/core';
import {
    ellipsisHorizontalSharp,
    ellipsisVerticalSharp,
    trash,
    pencil,
    close,
    mail,
    eye,
    cloudDownload,
    chevronDownCircleOutline,
    chevronUpCircleOutline,
    person
 } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { colorTheme } from '../../utils/constants';

// All actions
const A_VIEW = 'View';
const A_EDIT = 'Edit';
const A_CANCEL = 'Cancel';
const A_DELETE = 'Delete';
const A_SEND_RECEIPT = 'Send Receipt';
const A_RESEND_RECEIPT = 'Resend Receipt';
const A_SEND_INVOICE = 'Send Invoice';
const A_RESEND_INVOICE = 'Resend Invoice';
const A_DOWNLOAD_RECEIPT = 'Download Receipt';
const A_DOWNLOAD_INVOICE = 'Download Invoice';
const A_REALLOCATE_PAYMENT = 'Reallocate Payment';



const TenantTransactionsListItem = ({
    date, transactionId, message, description, moneyDue,
     moneyPaid, balance, amount, itemType, shortDescription,
      showDetails, handleSelectTransaction, userAllPerms
 }) => {

    const [showExtraDetails, setShowExtraDetails] = useState(false);

    const [present] = useIonActionSheet();

    const [extraData, setExtraData] = useState([
        {label: 'Date', value: date},
        {label: 'Transaction Id', value: transactionId},
        {label: 'Description', value: description},
        {label: 'Money Due', value: moneyDue},
        {label: 'Money Paid', value: moneyPaid},
        {label: 'Running balance', value: balance}
    ]);

    const actionsRequiringAllTransPerms = [A_EDIT, A_DELETE,A_VIEW, A_REALLOCATE_PAYMENT]
    const actionsRequiringAllMsgPerms = [A_RESEND_RECEIPT, A_RESEND_INVOICE, A_SEND_RECEIPT, A_SEND_INVOICE]

    useEffect(() => {
    }, [transactionId])


    const open = async () => {
        const mode = getMode();
        const canEdit = itemType === "Payment" ? userAllPerms.payment : userAllPerms.invoice;
        let iconToShow = canEdit ? pencil : eye;

        const buttons = [
            {
            text: canEdit ? A_EDIT : A_VIEW,
            role: 'destructive',
            icon: mode !== 'ios' ? iconToShow : '',
            handler: () => {
                handleSelectTransaction("edit", transactionId);
            },
            },
            {
            text: A_DELETE,
            icon: mode !== 'ios' ? trash : '',
            handler: () => {
                handleSelectTransaction("delete", transactionId);
            },
            },
            {
            text: message? itemType === "Payment"? A_RESEND_RECEIPT : A_RESEND_INVOICE: itemType === "Payment"? A_SEND_RECEIPT : A_SEND_INVOICE,
            icon: mode !== 'ios' ? mail : '',
            handler: () => {
                handleSelectTransaction(itemType === "Payment"? "sendReceipt": "sendInvoice", transactionId);
            },
            },
            {
            text: itemType === "Payment"? A_DOWNLOAD_RECEIPT: A_DOWNLOAD_INVOICE,
            icon: mode !== 'ios' ? cloudDownload : '',
            handler: () => {
                handleSelectTransaction(itemType === "Payment"? "downloadReceipt": "downloadInvoice", transactionId);
            },
            },
            {
            text: A_REALLOCATE_PAYMENT,
            icon: mode !== 'ios' ? person : '',
            handler: () => {
                handleSelectTransaction("reallocate", transactionId);
            },
            },
            {
            text: A_CANCEL,
            role: 'cancel',
            icon: mode !== 'ios' ? close : '',
            handler: () => {
            },
            },
        ];

        let filteredButtons = buttons;
        if(!userAllPerms.payment && itemType === "Payment"){
            filteredButtons = filteredButtons.filter((b) => !actionsRequiringAllTransPerms.includes(b.text));
        }
        if(itemType === "Invoice"){
            filteredButtons = filteredButtons.filter((b) => b.text !== A_REALLOCATE_PAYMENT);
        }
        if(!userAllPerms.invoice && itemType === "Invoice"){
            filteredButtons = filteredButtons.filter((b) => !actionsRequiringAllTransPerms.includes(b.text));
        }
        if(!userAllPerms.message){
            filteredButtons = filteredButtons.filter((b) => !actionsRequiringAllMsgPerms.includes(b.text));
        }

        present({
            header: transactionId + "  " + amount,
            buttons: filteredButtons
          });
      }

    useEffect(() => {
        setShowExtraDetails(showDetails);
    }, [showDetails])



    return (<div className='mx-1 mx-md-4'  key={transactionId}>
        <Row slot="start" style={{width: '100%'}} className='my-2 mx-0 py-1 shadow-sm rounded'>
          <Row className='rounded mx-0 px-0'
          >
            <Col onClick={ () => { setShowExtraDetails(!showExtraDetails)} }
                xs={11} md={10} className='mx-0 px-0'
            >
              <Row className='mx-0 px-0'>
                <Col xs={5}>
                    {date}
                    <IonIcon 
                        style={{fontSize: '20px', color: 'var(--ion-color-primary)', marginRight: '10px' }}
                        icon={!showExtraDetails ? chevronDownCircleOutline : chevronUpCircleOutline}
                    ></IonIcon>
                    <IonBadge color={itemType === "Payment" ? "success" : "warning"}>{itemType}</IonBadge>
                </Col>
                <Col xs={4} className='px-1'>
                    <IonText><strong>{itemType === "Payment" ? moneyPaid : moneyDue}</strong></IonText>
                </Col>
                <Col xs={3} className='flex justify-content-end justify-content-md-start mx-0 pl-0'>
                    {balance}
                </Col>
              </Row>
            </Col>

            <div onClick={open} style={{width: '25px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-1 d-block d-md-none'>
                  <IonIcon size="large" aria-hidden="true"  icon={ellipsisVerticalSharp} />
            </div>
            <div onClick={open} style={{width: '50px', color: 'var(--ion-color-primary)'}} className='my-0 px-0 py-0 d-none d-md-block'>
                  <IonIcon size="large" aria-hidden="true"  icon={ellipsisHorizontalSharp} />
            </div>

          </Row>

            {showExtraDetails && (<Row style={{backgroundColor: colorTheme["primary"]["25"], overflow: "hidden" }} className='mx-0 mb-2 px-0 py-3 rounded tenant-list-row'>
                <Row>
                    <IonButton 
                        fill="outline"
                        onClick={(e) => {
                            e.stopPropagation();
                            open();
                        }}
                    >
                        Options
                    </IonButton>
                </Row>
                { extraData.map((data, index) => (
                    <Row key={index} className='border-bottom my-1 ml-0.5'>
                      <Col  xs={4} md={3}><strong>{data.label}</strong></Col>
                      <Col xs={8} md={8}>
                        <span style={{fontSize: '16px'}}>{data.value}</span>
                      </Col>
                    </Row>
                  ))}
            </Row>)}
        </Row>
    </div>);
}

export default TenantTransactionsListItem;